import { useRef } from "react";
import Slider from "react-slick";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

var settings8 = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1400,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: false,
    cssEase: "ease",
};

export default function ServicesDetail({ service }) {
    const sliderRef = useRef(null);

    const CustomArrows = () => (
        <div className="build-arrows">
            <div className="default-arrowleft" onClick={() => sliderRef.current.slickPrev()}>
                <FontAwesomeIcon icon={faArrowLeft} />
            </div>
            <div className="default-arrowright" onClick={() => sliderRef.current.slickNext()}>
                <FontAwesomeIcon icon={faArrowRight} />
            </div>
        </div>
    );
    return (
        <>
            <section className="servicepage-detail">
                <div className="container">
                    <div className="row align-items-center">

                        <div className="col-lg-6 col-md-6">
                            <div className="serviceslide-image">
                                <Slider className="servicedetail-slider" ref={sliderRef} {...settings8}>
                                    {service?.servicedetailimage?.map((image, index) => (
                                        <img
                                            key={index}
                                            src={image.asset.url}
                                            className="img-responsive"
                                            alt="Service Detail"
                                            loading="lazy"
                                        />
                                    ))}
                                </Slider>

                                <img src="/assets/home/light-curve-2.svg" className='homebuild-shape' alt="shape" loading="lazy" />
                                <img src="/assets/home/light-curve-2.svg" className='homebuild-shape-2' alt="shape" loading="lazy" />
                            </div>
                        </div>

                        <div className='col-lg-6 col-md-6'>
                            <p className="servicepage-tag"><img src="/assets/home/star.png" alt="Star" /> interia practice areas</p>
                            <div className="build-slider">
                                <div className="buildslide-box">
                                    <h4 className='heading'>{service?.title || "Service Title"}</h4>
                                    <div>
                                        {service?.description?.map((block, idx) => (
                                            <p key={idx}>
                                                {block.children.map((child) => child.text).join(" ")}
                                            </p>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <CustomArrows />
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}
